export default __webpack_public_path__ + "static/media/OverActive.9579694e.svg";